import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from "react-router-dom";
import Index from './Pages/Index';
import About from './Pages/About';
import Contact from './Pages/Contact';
import Tours from './Pages/Tours/List';
import TourDetail from './Pages/Tours/Detail';
import TransferList from './Pages/Transfer/List';
import TransferDetail from './Pages/Transfer/Detail';
import Hotels from './Pages/Hotel/List';
import HotelDetail from './Pages/Hotel/Detail';
import Checkout from './Pages/Payment/Checkout';
import Cart from './Pages/Payment/Cart';
import Login from './Pages/Agency/Auth/Login';
import ProtectedRoute from './Pages/ProtectedRoute';
import DashboardIndex from './Pages/Dashboard/Index';
import AgencyRoute from './Pages/AgencyRoute';
import AgencyUserList from './Pages/Agency/User/List';
import AgencyUserAdd from './Pages/Agency/User/Add';
import GridList from './Pages/Hotel/GridList';
import GridList2 from './Pages/Hotel/GridList2';
import AgencyOrderList from './Pages/Agency/Order/List';
import AgencyProfile from './Pages/Agency/Account/ProfileSettings';
import AgencyChangePassword from './Pages/Agency/Account/ChangePassword';
import AgencyAccount from './Pages/Agency/Account/Edit';
import Wallet from './Pages/Agency/Wallet/List';
import BuyCoin from './Pages/Agency/Wallet/BuyCoin';
import AgencyUserEdit from './Pages/Agency/User/Edit';
import NotFound from './Pages/Error/NotFound';
import AgencyOrderDetail from './Pages/Agency/Order/Detail';
import SubAgencyList from './Pages/Agency/SubAgency/List';
import SubAgencyAdd from './Pages/Agency/SubAgency/Add';
import SubAgencyWalletAdd from './Pages/Agency/SubAgency/Wallet/Create';
import SubAgencyWalletHistory from './Pages/Agency/SubAgency/Wallet/History';
import EditSubAgency from './Pages/Agency/SubAgency/Edit';
import ForgotPassword from './Pages/Agency/Auth/ForgotPassword';
import EmailCode from './Pages/Agency/Auth/EmailCode';
import ResetPassword from './Pages/Agency/Auth/ResetPassword';
import Payment from './Pages/Payment/Payment';
import PaymentSuccessful from './Pages/Payment/PaymentSuccessful';
import PaymentFailed from './Pages/Payment/PaymentFail';
import { SidebarProvider } from './context/SidebarContext';
import { LanguageProvider } from './context/LanguageContext';
import { CurrencyProvider } from './context/CurrencyContext';
import Hotels2 from './Pages/Hotel/List2';
import Hotels3 from './Pages/Hotel/List3';
import Hotels4 from './Pages/Hotel/List4';
// Politika sayfaları
import Privacy from './Pages/Policies/Privacy';
import Cookie from './Pages/Policies/Cookie';
import Cancellation from './Pages/Policies/Cancellation';
import RepresentativeUser from './Pages/Agency/User/RepresentativeUser';
const App = () => {
  /* function HotelRouteWrapper({ defaultSlug, defaultStartDate, defaultEndDate }) {
    const { slug, startDate, endDate } = useParams();
  
    console.log("Route Params:", { slug, startDate, endDate }); // Debug için ekledik
  
    if (!slug || !startDate || !endDate) {
      console.log("Missing parameters, redirecting...");
      return <Navigate to={`/hotel-detail/${slug || defaultSlug}/${startDate || defaultStartDate}/${endDate || defaultEndDate}`} />;
    }
  
    return (
      <ProtectedRoute>
        <HotelDetail />
      </ProtectedRoute>
    );
  } */

  return (
    <LanguageProvider>
      <CurrencyProvider>
        <SidebarProvider>
          <Router>
            <Routes>
              <Route path="*" element={   <NotFound />} />
              <Route path="/" element={<ProtectedRoute><Index /></ProtectedRoute>} />
              <Route path="/about" element={<About />} />
              <Route path="/test" element={<GridList />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              
              {/* Politika Sayfaları */}
              <Route path="/privacy-policy" element={<Privacy />} />
              <Route path="/cookie-policy" element={<Cookie />} />
              <Route path="/cancellation-policy" element={<Cancellation />} />
              
              <Route path="/tours" element={<ProtectedRoute> <Tours/> </ProtectedRoute>} />
              <Route path="/tours/:id" element={<ProtectedRoute> <TourDetail /> </ProtectedRoute>} />
              
              <Route path="/transfers" element={<ProtectedRoute> <TransferList /> </ProtectedRoute>} />
              <Route path="/transfers/:id" element={<ProtectedRoute> <TransferDetail /> </ProtectedRoute>} />

              <Route 
                path="/hotels" 
                element={
                  <ProtectedRoute>
                    <Hotels4 />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/hotels-with-map" 
                element={
                  <ProtectedRoute>
                    <GridList2 />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/hotel-detail/:code/:slug" 
                element={
                  <ProtectedRoute>
                    <AgencyRoute>
                      <HotelDetail />
                    </AgencyRoute>
                  </ProtectedRoute>
                }
              />
              <Route path="/checkout" element={ <ProtectedRoute> <Checkout /> </ProtectedRoute>} />
              <Route path="/cart" element={ <ProtectedRoute> <Cart /> </ProtectedRoute>} />
              <Route path="/payment" element={ <ProtectedRoute> <Payment /> </ProtectedRoute>} />
              <Route path="/payment-successful" element={ <ProtectedRoute> <PaymentSuccessful /> </ProtectedRoute>} />
              <Route path="/payment-failed" element={ <ProtectedRoute> <PaymentFailed /> </ProtectedRoute>} />
              

              {/* HOTEL USER DASHBOARD */}
              <Route path="/dashboard" element={<ProtectedRoute > <AgencyRoute > <DashboardIndex /> </AgencyRoute> </ProtectedRoute>} />

              {/* AGENCY USER DASHBOARD */}
              <Route path="/dashboard-forgot-password" element={<ForgotPassword />} />
              <Route path="/dashboard-email-code" element={<EmailCode />} />
              <Route path="/dashboard-reset-password" element={<ResetPassword />} />

              <Route path="/dashboard-bookings" element={<ProtectedRoute> <AgencyRoute > <AgencyOrderList /> </AgencyRoute></ProtectedRoute>} />
              <Route path="/dashboard-bookings-detail" element={<ProtectedRoute> <AgencyRoute > <AgencyOrderDetail /> </AgencyRoute></ProtectedRoute>} />

              <Route path="/dashboard-settings" element={<ProtectedRoute> <AgencyRoute> <AgencyAccount /> </AgencyRoute></ProtectedRoute>} />
              <Route path="/dashboard-profile" element={<ProtectedRoute> <AgencyRoute> <AgencyProfile /> </AgencyRoute></ProtectedRoute>} />
              <Route path="/dashboard-change-password" element={<ProtectedRoute> <AgencyRoute> <AgencyChangePassword /> </AgencyRoute></ProtectedRoute>} />

              <Route path="/dashboard-sub-agency" element={<ProtectedRoute> <AgencyRoute > <SubAgencyList /> </AgencyRoute></ProtectedRoute>} />
              <Route path="/dashboard-sub-agency-add" element={<ProtectedRoute> <AgencyRoute > <SubAgencyAdd /> </AgencyRoute></ProtectedRoute>} />
              <Route path="/dashboard-sub-agency-edit/:id" element={<ProtectedRoute> <AgencyRoute > <EditSubAgency /> </AgencyRoute></ProtectedRoute>} />

              <Route path="/dashboard-sub-agency-wallet-history" element={<ProtectedRoute> <AgencyRoute > <SubAgencyWalletHistory /> </AgencyRoute></ProtectedRoute>} />
              <Route path="/dashboard-sub-agency-wallet-create" element={<ProtectedRoute> <AgencyRoute > <SubAgencyWalletAdd /> </AgencyRoute></ProtectedRoute>} />

              <Route path="/dashboard-representative-user" element={<ProtectedRoute> <AgencyRoute > <RepresentativeUser /> </AgencyRoute></ProtectedRoute>} />

              <Route path="/dashboard-users" element={<ProtectedRoute> <AgencyRoute > <AgencyUserList /> </AgencyRoute></ProtectedRoute>} />
              <Route path="/dashboard-user-add" element={<ProtectedRoute> <AgencyRoute > <AgencyUserAdd /> </AgencyRoute></ProtectedRoute>} />
              <Route path="/dashboard-user-edit/:id" element={<ProtectedRoute> <AgencyRoute > <AgencyUserEdit /> </AgencyRoute></ProtectedRoute>} />
              <Route path="/dashboard-credit" element={<ProtectedRoute> <AgencyRoute > <Wallet /> </AgencyRoute></ProtectedRoute>} />
              <Route path="/dashboard-buy-coin" element={<ProtectedRoute> <AgencyRoute> <BuyCoin /> </AgencyRoute></ProtectedRoute>} />

            </Routes>
          </Router>
        </SidebarProvider>
      </CurrencyProvider>
    </LanguageProvider>
  );
}

export default App;
